import { Component, Input, OnInit } from '@angular/core';
import { StateRegistrationAddress } from '../../../models/registration-address.model';

@Component({
    selector: 'app-registered-office-address-section',
    templateUrl: './registered-office-address-section.component.html',
    styleUrls: ['./registered-office-address-section.component.scss'],
    standalone: false
})
export class RegisteredOfficeAddressSectionComponent implements OnInit {
  @Input() address?: StateRegistrationAddress;

  /** Lease dates exist only on applications filled in after the lease group was added to the form. */
  get hasLeasePeriod(): boolean {
    return !!this.address?.startDate || !!this.address?.endDate;
  }

  ngOnInit(): void {
  }
}
